// extracted by mini-css-extract-plugin
export default {"container":"EditProject_container__skGIb"};